import { Moment } from 'moment';
import { BancoResponse, InstrumentoFinanceiro, InvestidorResponse, InvestidorResumo, ParticipanteResponse } from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import { Field } from 'm2m.components';
import { initialEmissor } from 'pages/cra/detalhes/initialCra';

export interface CadastroMovimentacaoState {
  tipoAtivo: InstrumentoFinanceiro;
  emissor: ParticipanteResponse;
  dataAgendamento: Moment | null;
  tipoPesquisa: 'CODIGO' | 'EMISSOR';
  tipoMovimentacao: 'OFERTA_PRIMARIA' | 'COMPRA' | 'VENDA';
  codigoInstrumento: string;
  instrumentoId: string;
  modalidadeLiquidacao: 'BRUTA' | 'DIRETA';
  instrumentoPU: number;
  contraparte: {
    contaDeposito: string | null;
    investidor: InvestidorResumo | InvestidorResponse | null;
    participante: ParticipanteResponse | null;
  },
  parte: {
    contaDeposito: string | null;
    investidor: InvestidorResumo | InvestidorResponse | null;
    participante: ParticipanteResponse | null;
    dadosBancarios: {
      conta: string | null;
      agencia: string | null;
    } | null
  },
  bancoPagador: BancoResponse | null,
  bancoRecebedor: BancoResponse | null
}
 
export const cadastroMovimentacaoInitialState: CadastroMovimentacaoState = {
  tipoAtivo: InstrumentoFinanceiro.NotaComercial,
  emissor: initialEmissor,
  dataAgendamento: null,
  tipoPesquisa: 'CODIGO',
  tipoMovimentacao: 'OFERTA_PRIMARIA',
  codigoInstrumento: '',
  instrumentoId: '',
  modalidadeLiquidacao: 'DIRETA',
  instrumentoPU: 0,
  contraparte: {
    contaDeposito: null,
    investidor: null,
    participante: null
  },
  parte: {
    contaDeposito: null,
    investidor: null,
    participante: null,
    dadosBancarios: null
  },
  bancoPagador: null,
  bancoRecebedor: null
};

export const updateField = (field: Field) => {
  return typedAction('cadastroMovimentacao/UPDATEFIELD', field);
};

export const resetCadastroMovimentacao = () => {
  return typedAction('cadastroMovimentacao/RESET');
};

export const updateCadastroMovimentacao = (state: CadastroMovimentacaoState) => {
  return typedAction('cadastroMovimentacao/UPDATE', state);
};

export type CadastroMovimentacaoAction = ReturnType<
  | typeof updateField
  | typeof updateCadastroMovimentacao
  | typeof resetCadastroMovimentacao
>;
